import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, Group, LoadingOverlay } from '@mantine/core'
import { showNotification } from '@mantine/notifications'
import { MainLayout } from '../../layouts'
import { ContentBox, BackListButton, SaveButton, ResetButton } from '../../partials'
import { FormTypes } from '../../../types'
import { useAppDispatch, useAppSelector } from '../../../store'
import { IModelDetailParams } from '../../../store/types'
import { IFormRef } from '../../../types'
import { getFormattedValidationErrors } from '../../../utils/mixins'
import Form from './Form'
import {
  fetchCreateModelDetail,
  resetCreateModelDetail
} from '../../../store/features/modelDetails/createModelDetailSlice'

const Create = () => {
  const { t } = useTranslation()
  const formRef = useRef<IFormRef>(null)
  const dispatch = useAppDispatch()

  const { isLoading, response, error } = useAppSelector(state => state.createModelDetail)

  useEffect(() => {
    if (response !== null) {
      showNotification({
        color: 'green',
        title: t('successful'),
        message: t('created')
      })

      dispatch(resetCreateModelDetail())
    }
  }, [response, t, dispatch])

  useEffect(() => {
    if (error !== null) {
      if (error.response.status === 422) {
        formRef.current!.setErrors(getFormattedValidationErrors(error))
      } else {
        showNotification({
          color: 'red',
          title: t('unsuccessful'),
          message: error.response.data ? error.response.data.message : t('errors.unknown')
        })
      }
    }
  }, [error, t])

  useEffect(() => {
    if (response !== null) {
      dispatch(resetCreateModelDetail())
      formRef.current!.reset()
    }
  }, [response, dispatch])

  const handleSubmit = async (data: IModelDetailParams) => {
    await dispatch(fetchCreateModelDetail(data))
  }

  return (
    <MainLayout>
      <LoadingOverlay visible={isLoading} />
      <ContentBox title={t('content_actions.create')}>
        <Form
          id="create-modelDetail-form"
          type={FormTypes.CREATE}
          ref={formRef}
          initialValues={{
            name: '',
            model_id: ''
          }}
          onSubmit={handleSubmit}
        />
      </ContentBox>
      <ContentBox>
        <Grid>
          <Grid.Col span={6}>
            <BackListButton to="/model-details" />
          </Grid.Col>
          <Grid.Col span={6}>
            <Group position="right">
              <SaveButton form="create-modelDetail-form" />
              <ResetButton form="create-modelDetail-form" />
            </Group>
          </Grid.Col>
        </Grid>
      </ContentBox>
    </MainLayout>
  )
}

export default Create
